// extracted by mini-css-extract-plugin
export default {"container":"styles_container__eyAJl","subtitle":"styles_subtitle__thQeL","signupButton":"styles_signupButton__V9iep"};